import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

export default function initReviewsVideoSwiper() {
  const swiper = new Swiper(".reviews__slider2", {
    direction: "horizontal",
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    autoHeight: true,
    
    // Навигация
    navigation: {
      nextEl: ".reviews2-button-next",
      prevEl: ".reviews2-button-prev",
    },
    
    // Пагинация (опционально)
    pagination: {
      el: ".reviews2-pagination",
      clickable: true,
    },
    
    // Адаптивность
    breakpoints: {
      640: {
        slidesPerView: 1.5,
        spaceBetween: 20,
        autoHeight: false,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
        autoHeight: false,
      },
      1024: {
        slidesPerView: 2.5,
        spaceBetween: 25,
        autoHeight: false,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 30,
        autoHeight: false,
      },
    },
    
    // Настройки производительности
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
    },
    
    // События Swiper
    on: {
      init: function() {
        // console.log("Видео слайдер инициализирован");
      },
      slideChange: function() {
        // console.log("Слайд изменён:", this.activeIndex);
      },
    },
  });
  
  return swiper;
}